export function hasPermission(
  userPermissions: string[] | undefined,
  requiredPermission: string,
): boolean {
  if (!userPermissions?.length) return false;

  return userPermissions.some((permission) => {
    if (
      permission === requiredPermission ||
      permission === "*" ||
      permission === "*.*"
    ) {
      return true;
    }
    if (!permission.endsWith(".*")) return false;
    const namespace = permission.slice(0, -2);
    return (
      requiredPermission === namespace ||
      requiredPermission.startsWith(`${namespace}.`)
    );
  });
}

export function hasAnyPermission(
  userPermissions: string[] | undefined,
  requiredPermissions: readonly string[],
): boolean {
  return requiredPermissions.some((permission) =>
    hasPermission(userPermissions, permission),
  );
}

export const ROUTE_PERMISSION_MAP: ReadonlyArray<{
  pathPrefix: string;
  permissions: readonly string[];
}> = [
  { pathPrefix: "/purchasing/invoices", permissions: ["purchasing.invoices.read", "purchasing.invoices.create"] },
  { pathPrefix: "/accounting/journal-entries", permissions: ["accounting.journal_entries.read"] },
  { pathPrefix: "/accounting/reports", permissions: ["accounting.reports"] },
  { pathPrefix: "/admin", permissions: ["audit.read", "settings.read"] },
  { pathPrefix: "/users", permissions: ["users.read"] },
  {
    pathPrefix: "/accounting",
    permissions: ["accounting.gl_accounts.read", "accounting.reports"],
  },
  {
    pathPrefix: "/suppliers",
    permissions: ["purchasing.suppliers.read", "purchasing.suppliers.create"],
  },
  { pathPrefix: "/branches", permissions: ["branches.read"] },
  {
    pathPrefix: "/reports",
    permissions: [
      "reporting.sales.read",
      "reporting.inventory.read",
      "reporting.financial.read",
      "reporting.dashboard.read",
    ],
  },
  {
    pathPrefix: "/warehouses",
    permissions: ["warehouses.read", "inventory.read"],
  },
  { pathPrefix: "/pos", permissions: ["pos.create", "sales.create"] },
  { pathPrefix: "/sales", permissions: ["sales.read", "sales.create"] },
  { pathPrefix: "/customers", permissions: ["customers.read"] },
  {
    pathPrefix: "/purchasing",
    permissions: ["purchasing.orders.read", "purchasing.orders.create"],
  },
  { pathPrefix: "/returns", permissions: ["returns.read", "returns.create"] },
  { pathPrefix: "/products", permissions: ["products.read"] },
  { pathPrefix: "/inventory", permissions: ["inventory.read"] },
  {
    pathPrefix: "/settings",
    permissions: ["settings.read", "settings.update"],
  },
];

export function canAccessPathByPermissions(
  pathname: string,
  userPermissions: string[] | undefined,
): boolean {
  const requirement = ROUTE_PERMISSION_MAP.find(
    ({ pathPrefix }) =>
      pathname === pathPrefix || pathname.startsWith(`${pathPrefix}/`),
  );
  if (!requirement) return true;
  return hasAnyPermission(userPermissions, requirement.permissions);
}
